<template name="createScript">
  <div id="wholePage">
    <div class="modeBtns">
      <el-button type="primary" @click="saveSript(0)" class="previewModeBtn">保存</el-button>
      <el-button type="primary" @click="publishScript()" class="previewModeBtn">发布</el-button>
      <el-button type="success" @click="add('if(,,)')" class="previewModeBtn">if</el-button>
      <el-button type="success" @click="add('sin()')" class="previewModeBtn">sin</el-button>
      <el-button type="success" @click="add('cos()')" class="previewModeBtn">cos</el-button>
      <el-button type="success" @click="add('tan()')" class="previewModeBtn">tan</el-button>
      <el-button type="success" @click="add('pow(,)')" class="previewModeBtn">pow</el-button>
      <el-button type="success" @click="add('abs()')" class="previewModeBtn">abs</el-button>
    </div>

    <div id="create">
      <div id="right_menu">
        <draggable-dialog class="draggableDialog"
                          :closable="false"
                          width='90%'
                          top='0px'
                          left='10px'
                          position='fixed'
        >
          <template slot="header">
            脚本说明区
          </template>
          <template slot="content">
            <div class="content6">
              <div style="height: 700px">
                <div>
                  基本规则<br/>
                  1. 变量名统一用[]括起来。<br/>
                  2. 算术运算符：+ 、-、*、/、%<br/>
                  3. 逻辑运算符：&&、||、！<br/>
                  4. 比较运算符：=、&lt;、&lt;=、&gt;、&gt;=、!=<br/>
                  5. 位运算符：&、|、^、~<br/>
                  6. 小括号<br/>
                  7. 数字<br/>
                  8. 一些内置函数，IF(表达式1，表达式2，表达式3)、SIN(数值)、COS(数值)、TAN(数值)、POW(数值1，数值2)、ABS(数值)<br/>
                  <br/>
                  <br/>
                  脚本格式：<br/>
                  简单的设置变量关系<br/>
                  [变量名] = 表达式<br/>
                  <br/>
                  条件分支： [变量名] =<br/>
                  CASE<br/>
                  WHEN 表达式 THEN 表达式<br/>
                  WHEN 表达式 THEN 表达式<br/>
                  ELSE 表达式<br/>
                  END<br/>
                  <br/>
                  其中表达式格式：<br/>
                  [变量名]/数字/内置函数() + 运算符(算术、逻辑、比较均可) + [变量名]/数字/内置函数()<br/>
                </div>
              </div>
            </div>
            <div style="clear: both;"></div>
          </template>
        </draggable-dialog>
      </div>
      <div id="content" @mouseup="myDown" @keyup.left="myDown" @keyup.right="myDown">
        <el-autocomplete
            cols="160"
            rows="25"
            type="textarea"
            id="input"
            class="inline-input"
            v-model="content"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelect"

            :trigger-on-focus="false"
        ></el-autocomplete>
      </div>
    </div>
    <el-dialog
        title="提示"
        :visible.sync="exitDialogVisiable"
        width="30%"
    >
      <span>是否确认离开此页面(若未保存将丢失修改记录)？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelExit">取 消</el-button>
        <el-button type="primary" @click="confirmExit">确 定</el-button>
     </span>
    </el-dialog>
  </div>
</template>
<script>
import DraggableDialog from "@/components/ProductComponents/CreateComponents/DraggableDialog";
import CheckMixin from"@/components/ScriptComponents/Mixins/CheckMixin"

import API from "../../../config/api.js";
export default {
  name: "createScript",
  components: {
    DraggableDialog
  },
  mixins:[CheckMixin],
  data() {
    return {
      script: '',
      variableList: [],
      variableIdList: [],
      updateVariableId: '',
      updateVariable: '',
      TriggerVariableIds: '',
      userId: '',
      datas: [],
      content: '',
      tmp_content: '',
      l: "",
      r: "",
      pos: "",
      cb_tmp: "",
      state: 0,

      //跳转页面的Dialog
      exitDialogVisiable: false,
      //退出使用
      exitFunc: null,
      exitNode: null
    }
  },
  //此处定义传入的数据
  props: {
    companyId: Number,
    scriptId: Number,
  },
  mounted() {
    this.getScript();
    this.getVariableList();
    this.userId = window.localStorage.getItem('userid');
  },
  updated() {
    // 页面更新后根据state的状态,看看要不要设置光标的位置
    if (this.state === 1) {
      this.state = 0
      this.setCaretPosition(document.getElementById("input"), this.l)
    }
  },
  methods: {
    publishScript() {
      this.saveSript(1);
      console.log(this.content)
      let res = this.check(this.content, this.variableList)
      if (res !== "未发现问题") {
        this.$message({
          message: res,
          type: 'warning',
        })
        return
      }

      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        id: this.script["id"],
        userId: this.userId,
        scriptSource: encodeURIComponent(this.content),
        description: this.script["description"],
        TriggerVariableIds: this.TriggerVariableIds + ",",
      }
      // console.log(data)
      this.$axiosRequest({
        url: API.publishScript,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          //console.log("res,",res.data)
          if (res.data == -3) {
            this.$message({
              message: '脚本执行错误！',
              type: 'warning',
            })
          } else if (res.data == -2) {
            this.$message({
              message: '参数出错！',
              type: 'warning',
            })
          } else if (res.data == -1) {
            //console.log("系统错误")
            this.$message({
              message: '参数出错或系统错误，发布失败',
              type: 'warning',
            })
          } else if (res.data > 0) {
            this.$message({
              message: '发布成功！',
              type: 'success',
            })
          }
        }
      });
    },
    // 获得当前脚本内容
    getScript() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        id: this.scriptId
      }
      //console.log(data)
      this.$axiosRequest({
        url: API.getScriptById,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          //console.log("res:",res)
          this.script = res.data['script']
          //console.log("script:",this.script)
          this.content = this.script["scriptSource"]
          this.updateVariableId = this.script["updateVariableId"]
        }
      });
    },
    // 获得公司的所有变量
    getVariableList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
      }

      this.$axiosRequest({
        url: API.getVariableList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          let variableList = res.data["variableList"]
          // console.log("variableList：",variableList, variableList.length)
          for (let i = 0; i < variableList.length; i++) {
            // console.log(variableList[i]['variableName'])
            let value = "[" + variableList[i]['variableName'] + "]"
            let data = {
              "value": value
            }
            this.datas.push(data);
            this.variableList.push(variableList[i]['variableName'].toLowerCase());
            this.variableIdList.push(variableList[i]['id']);
          }
        }

      });
    },
    // 保存脚本
    saveSript(flag) {
      for (let i = 0; i < this.variableIdList.length; i++) {
        console.log("查询中",this.variableIdList[i],this.updateVariableId)
        if (this.variableIdList[i] === this.updateVariableId) {
          this.updateVariable = this.variableList[i];
          break;
        }
      }
      this.content = this.pre_done(this.content);
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        id: this.script["id"],
        scriptSource: encodeURIComponent(this.content),
        description : this.script["description"],
      }
      // console.log("保存的数据为:",data)
      this.$axiosRequest({
        url: API.updateScript,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          //console.log("res,",res.data)
          if (res.data === 0) {
            this.$message({
              message: '已存在该标题脚本！',
              type: 'warning',
            })
          } else if (res.data === -2) {
            this.$message({
              message: '参数出错！',
              type: 'warning',
            })
          } else if (res.data === -1) {
            //console.log("系统错误")
            this.$message({
              message: '系统错误！',
              type: 'warning',
            })
          } else if (flag !== 1) {
            this.$message({
              message: '保存成功！',
              type: 'success',
            })
          }
        }
      });
    },
    //鼠标按下事件
    myDown() {
      // this.sleep(2000);
      if (this.cb_tmp !== '') this.cb_tmp([]);
      this.pos = this.getCursorPosition(document.getElementById("input"));
      //console.log("鼠标点击了文本框",this.pos);
    },
    add(text) {
      //this.pos = this.getCursorPosition(document.getElementById("input"));
      //console.log("点击了添加")
      let v1 = this.content.substring(0, this.pos);  // 切割左右端点
      let v2 = this.content.substring(this.pos);
      this.pos += text.length
      this.content = v1 + text + v2;
    },
    // 输入框有变化时执行该函数
    querySearch(queryString, cb) {
      this.cb_tmp = cb;
      // 临时变量记录下当前文本框的内容
      this.tmp_content = this.content
      // 找到当前光标位置
      let pos = this.getCursorPosition(document.getElementById("input"));
      this.pos = pos;
      // 若选择了建议文本,更新的右端点就在现在这里
      this.r = pos
      let i = this.r - 1;
      let flag = 0
      while (i >= 0 && queryString[i] !== '[') {
        if (queryString[i] === ']') flag = 1;
        i--;
      }
      if (i < 0 || flag === 1) {
        cb([]);
        return
      }
      // 找左端点,必须有[
      this.l = i;
      // 用这一小段来查询
      queryString = queryString.substring(this.l, this.r);
      var datas = this.datas;
      var results = queryString ? datas.filter(this.createFilter(queryString)) : datas;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (data) => {
        return (data.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.content = this.tmp_content    // 选择了之后content就变了,重新回到原来的样子
      let v1 = this.content.substring(0, this.l);  // 切割左右端点
      let v2 = this.content.substring(this.r);
      // console.log(v1,v2,this.l,this.r)
      this.content = v1 + item.value + v2;    // 更新现在的内容
      console.log("应该要定位的位置为：", this.l + item.value.length)
      this.l += item.value.length
      this.state = 1
      // this.setCaretPosition(document.getElementById("input"),this.l+item.value.length)
      //console.log(item.value);
    },
    // 获得光标位置
    getCursorPosition(element) {
      let cursorPos = 0;
      // IE浏览器
      if (document.selection) {
        var selectRange = document.selection.createRange();
        selectRange.moveStart('character', -element.value.length);
        cursorPos = selectRange.text.length;
      } else if (element.selectionStart || element.selectionStart == '0') {
        cursorPos = element.selectionStart;
      }
      return cursorPos;
    },

    // 设置光标位置
    setCaretPosition(textDom, pos) {
      if (textDom.setSelectionRange) {
        // IE Support
        textDom.focus();
        textDom.setSelectionRange(pos, pos);
      } else if (textDom.createTextRange) {
        // Firefox support
        var range = textDom.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
      }
    },

    // 把内容的多个空格转化为单个,把[]里的空格回车都删除
    // pre_done(content) {
    //   let res = "";
    //   for (let i = 0; i < content.length; i++) {
    //     if (i > 0 && (content[i] === ' ' || content[i] === '\n') && content[i] === content[i - 1]) continue;
    //     res += content[i];
    //   }
    //   res = res.replace("[ ", "[").replace(" ]", ']');
    //   res = res.replace("[\n", "[").replace("\n]", ']');
    //   return res;
    // },
    //
    // checkVariable(content, varablies) {
    //   if (!content.startsWith('[')) return "找不到符号[";
    //   if (!content.endsWith(']')) return "找不到符号]";
    //   content = content.substr(1, content.length - 2);
    //   if (varablies.includes(content)) {
    //     for (let i = 0; i < this.variableIdList.length; i++) {
    //       if (varablies[i] === content) {
    //         if (this.variableIdList[i] === this.updateVariableId) break;
    //         this.TriggerVariableIds += "," + this.variableIdList[i];
    //         break;
    //       }
    //     }
    //     return "未发现问题";
    //   } else return "不存在相应的变量：" + content;
    // },
    //
    // checkExpression(content, varablies) {
    //   let ops = ["+", "-", "*", "/", "%", "&&", "||", "=", "<", "<=", ">", ">=", "!=", "&", "|", "^"];
    //   let functionName = ["if", "abs", "sin", "cos", "tan", "pow"];
    //   let num = 0;     // 括号数量
    //   let val = [], op = [];   // 运算数值列表和运算符列表
    //   let msg = "";
    //   let tmp1 = 0, flag = 0, tmp2 = "";   // tmp1是当前数值,flag标记前方有-和~，tmp2是运算符
    //   for (let i = 0; i < content.length; i++) {
    //     if (content[i] === '!') {     // !单独处理
    //       let j = i + 1;
    //       while (j < content.length && (content[j] === ' ' || content[j] === '(' || content[j] === ')')) j++;
    //       if (j === content.length || ops.includes(content[j])) return "多余的运算符：!";
    //       continue;
    //     }
    //     if (content[i] === ' ') {   // 碰到空格,把当前的数值整理入列表
    //       if (flag !== 0) {
    //         if (op.length > 0) {
    //           let tmpOp = op[op.length - 1];
    //           if (tmp1 === 0 && flag === 1 && (tmpOp === "/" || tmpOp === "%")) {   // 当前是除或取模,但是数值是0
    //             return "出现除0或取模0错误";
    //           }
    //         }
    //         if (flag !== 1 && tmp1 === 0) {
    //           if (flag === -2) return "不合法的运算符:~";
    //           else return "不合法的运算符:-";
    //         }
    //         if (val.length > op.length) return tmp1 * flag + "前缺少运算符";   // 值已经大于运算符数量了,还加,说明运算符缺失了
    //         val.push(tmp1 * flag);
    //         tmp1 = 0;
    //         flag = 0;
    //       }
    //       if (tmp2 !== "") {
    //         if (!(ops.includes(tmp2))) {
    //           return "不合法的运算符:" + tmp2;
    //         }
    //         op.push(tmp2);
    //         if (op.length > val.length) return "多余的运算符：" + tmp2;
    //         tmp2 = "";
    //       }
    //       continue;
    //     }
    //     if (content[i] === '(') num++;
    //     else if (content[i] === ')') num--;
    //     else if (content[i] === '[') {     // 是变量
    //       if (flag !== 0) {
    //         if (op.length > 0) {
    //           let tmpOp = op[op.length - 1];
    //           if (tmp1 === 0 && flag === 1 && (tmpOp === "/" || tmpOp === "%")) {   // 当前是除或取模,但是数值是0
    //             return "出现除0或取模0错误";
    //           }
    //         }
    //         if (flag !== 1 && tmp1 === 0) {
    //           if (flag === -2) return "不合法的运算符:~";
    //           else return "不合法的运算符:-";
    //         }
    //         if (val.length > op.length) return tmp1 * flag + "前缺少运算符";   // 值已经大于运算符数量了,还加,说明运算符缺失了
    //         val.push(tmp1 * flag);
    //         tmp1 = 0;
    //         flag = 0;
    //       }
    //       if (tmp2 !== "") {
    //         if (!(ops.includes(tmp2))) {
    //           return "不合法的运算符:" + tmp2;
    //         }
    //         op.push(tmp2);
    //         if (op.length > val.length) return "多余的运算符：" + tmp2;
    //         tmp2 = "";
    //       }
    //       let j = i;
    //       let tmp = "";
    //       while (j < content.length && content[j] !== ']') {
    //         tmp += content[j];
    //         j++;
    //       }
    //       if (j < content.length) tmp += content[j];
    //       let msg = this.checkVariable(tmp, varablies);
    //       if (msg !== "未发现问题") return msg;
    //       i = j;
    //       if (val.length > op.length) return tmp + "前缺少运算符";
    //       val.push(1);   // 变量也是一个运算值
    //     } else if (content[i] >= 'a' && content[i] <= 'z') {   // 是函数
    //       if (flag !== 0) {
    //         if (op.length > 0) {
    //           let tmpOp = op[op.length - 1];
    //           if (tmp1 === 0 && flag === 1 && (tmpOp === "/" || tmpOp === "%")) {   // 当前是除或取模,但是数值是0
    //             return "出现除0或取模0错误";
    //           }
    //         }
    //         if (flag !== 1 && tmp1 === 0) {
    //           if (flag === -2) return "不合法的运算符:~";
    //           else return "不合法的运算符:-";
    //         }
    //         if (val.length > op.length) return tmp1 * flag + "前缺少运算符";   // 值已经大于运算符数量了,还加,说明运算符缺失了
    //         val.push(tmp1 * flag);
    //         tmp1 = 0;
    //         flag = 0;
    //       }
    //       if (tmp2 !== "") {
    //         if (!(ops.includes(tmp2))) {
    //           return "不合法的运算符:" + tmp2;
    //         }
    //         op.push(tmp2);
    //         if (op.length > val.length) return "多余的运算符：" + tmp2;
    //         tmp2 = "";
    //       }
    //       let j = i;
    //       let name = "";
    //       while (j < content.length && content[j] !== '(') {  // 取到第一个左括号
    //         name += content[j];
    //         j++;
    //       }
    //       if (!functionName.includes(name)) return "函数" + name + "不存在";   // tmp现在是函数名
    //       if (j >= content.length) return "函数" + name + "缺失(";
    //       if (val.length > op.length) return "函数" + name + "前缺少运算符";
    //       val.push(1);    // 函数也是一个运算值
    //       j++;
    //       let num = 1;
    //       let tmp = "";
    //       while (j < content.length && num !== 0) {   // 函数的括号内容
    //         if (content[j] === '(') num++;
    //         else if (content[j] === ')') num--;
    //         if (num !== 0) tmp += content[j];
    //         j++;
    //       }
    //       if (j === content.length && num !== 0) return "函数" + name + "缺失)"
    //       let cnt = 0;   // 参数个数
    //       let tmpx = "";  // 参数根据,分隔,分别获取并且判断合法性
    //       for (let j = 0; j < tmp.length; j++) {
    //         if (tmp[j] === ',') {
    //           if (num !== 0) {
    //             tmpx += tmp[j];
    //             continue;
    //           }
    //           cnt++;
    //           msg = this.checkExpression(tmpx, varablies);   // 判断是否是一个合法的表达式
    //           if (msg !== "未发现问题") return msg;
    //           tmpx = "";
    //         } else {
    //           tmpx += tmp[j];
    //           if (tmp[j] === '(') num++;
    //           else if (tmp[j] === ')') num--;
    //         }
    //       }
    //       if (tmpx !== "") {
    //         cnt++;
    //         msg = this.checkExpression(tmpx, varablies);
    //         if (msg !== "未发现问题") return msg;
    //         tmpx = "";
    //       } else {
    //         return "参数内容缺失";
    //       }
    //       if (name === "if") {    // if需要3个参数,其他的只需要1个
    //         if (cnt !== 3) return "函数" + name + "的参数个数不正确";
    //       } else if (name === "pow") {
    //         if (cnt !== 2) return "函数" + name + "的参数个数不正确";
    //       } else {
    //         if (cnt !== 1) return "函数" + name + "的参数个数不正确";
    //       }
    //       i = j - 1;
    //     } else {
    //       if ((content[i] >= '0' && content[i] <= '9') || ((tmp2 !== "" || op.length === 0) && content[i] === '-' && (flag === 0 || flag === -2)) ||
    //           (flag === 1 && content[i] === '.') || ((flag === 0 || flag === -1) && content[i] === '~')) {
    //         // 是数字，可能带负号,但是要保证之前没出现过运算符(出现在首位)或当前已经有运算符了(比如+ -5)并且之前未出现数字,也可能带小数点,必须保证小数点前面有数字
    //         // 可能有~运算符修饰,~出现时,必须保证之前未出现过数字,但可以前面是-
    //         if (tmp2 !== "") {
    //           if (!(ops.includes(tmp2))) {
    //             return "不合法的运算符:" + tmp2;
    //           }
    //           op.push(tmp2);
    //           if (op.length > val.length) return "多余的运算符：" + tmp2;
    //           tmp2 = "";
    //         }
    //         if (content[i] === '-') flag = -1;
    //         else if (content[i] === '~') flag = -2;
    //         else {
    //           flag = 1;
    //           tmp1 = tmp1 * 10 + (content[i] - '0');
    //         }
    //       } else {
    //         if (flag !== 0) {
    //           if (op.length > 0) {
    //             let tmpOp = op[op.length - 1];
    //             if (tmp1 === 0 && flag === 1 && (tmpOp === "/" || tmpOp === "%")) {   // 当前是除或取模,但是数值是0
    //               return "出现除0或取模0错误";
    //             }
    //           }
    //           if (flag !== 1 && tmp1 === 0) {
    //             if (flag === -2) return "不合法的运算符:~";
    //             else return "不合法的运算符:-";
    //           }
    //           if (val.length > op.length) return tmp1 * flag + "前缺少运算符";   // 值已经大于运算符数量了,还加,说明运算符缺失了
    //           val.push(tmp1 * flag);
    //           tmp1 = 0;
    //           flag = 0;
    //         }
    //         tmp2 += content[i];
    //       }
    //     }
    //   }
    //   if (flag !== 0) {
    //     if (op.length > 0) {
    //       let tmpOp = op[op.length - 1];
    //       if (tmp1 === 0 && flag === 1 && (tmpOp === "/" || tmpOp === "%")) {   // 当前是除或取模,但是数值是0
    //         return "出现除0或取模0错误";
    //       }
    //     }
    //     if (flag !== 1 && tmp1 === 0) {
    //       if (flag === -2) return "不合法的运算符:~";
    //       else return "不合法的运算符:-";
    //     }
    //     if (val.length > op.length) return tmp1 * flag + "前缺少运算符";   // 值已经大于运算符数量了,还加,说明运算符缺失了
    //     val.push(tmp1 * flag);
    //     tmp1 = 0;
    //     flag = 0;
    //   }
    //   if (tmp2 !== "") return "多余的运算符：" + tmp2;
    //   if (num !== 0) return "括号不匹配";
    //   if (val.length === 0) return "表达式" + content + "没有运算值";
    //   return "未发现问题";
    // },
    //
    // check(content, varablies) {
    //   let msg = ""
    //   content = content.replace(/\n/g, " ").toLowerCase().trim();     // 处理回车,全部转小写,去除前后空格
    //   //console.log("content",content)
    //   let id = content.indexOf("=");
    //   if (id === -1) return "格式错误,不存在=号";
    //   let pre = content.substr(0, id).trim()     // 截取等号前面内容
    //   msg = this.checkVariable(pre, varablies)              // 检查变量是否存在和格式问题
    //   if (msg !== "未发现问题") return msg
    //   let variable = pre.substring(1, pre.length - 1)
    //   if (variable !== this.updateVariable) {
    //     return "要更新的变量不符合初始设定"
    //   }
    //   content = content.substr(id + 1, content.length - id - 1).trim();  // 截取等号后面内容
    //   let inj_str = "call|create|alter|select|insert|delete|update|truncate|declare";
    //   let inj_stra = inj_str.split("|");
    //   for (let i = 0; i < inj_stra.length; i++) {
    //     if (content.indexOf(inj_stra[i]) !== -1) {
    //       return "脚本包含sql关键字";
    //     }
    //   }
    //   if (content.startsWith("case")) {    // 以case开头的
    //     if (!content.endsWith("end")) {  // end结尾
    //       return "格式错误,缺少end"
    //     }
    //     content = content.substr(4, content.length - 4 - 3);   // 截取中间内容
    //     let tmp = content.split("when");     // 按when分隔
    //     let elseNum = 0;           // 记录else的数量，最多只能一个
    //     for (let i = 0; i < tmp.length; i++) {
    //       tmp[i] = tmp[i].trim();
    //       if (tmp[i].length === 0) continue;
    //       let v = tmp[i].split("then");    // 按then分隔,这样就只剩下两个表达式了
    //       if (v.length !== 2) {
    //         if (v.length < 2) return "缺少关键字then";
    //         else return "then出现多次";
    //       }
    //       v[0] = v[0].trim();
    //       v[1] = v[1].trim();
    //       msg = this.checkExpression(v[0], varablies);    // 检查表达式
    //       if (msg !== "未发现问题") return msg;
    //       if (v[1].indexOf("else") !== -1) {       // 后面这个表达式可能存在else
    //         elseNum++;
    //         let tmpx = v[1].split("else");
    //         if (tmpx.length > 2) return "else 出现多次";
    //         msg = this.checkExpression(tmpx[0], varablies);
    //         if (msg !== "未发现问题") return msg;
    //         msg = this.checkExpression(tmpx[1], varablies);
    //         if (msg !== "未发现问题") return msg;
    //       } else {
    //         msg = this.checkExpression(v[1], varablies);
    //         if (msg !== "未发现问题") return msg;
    //       }
    //     }
    //     if (elseNum > 1) return "else 出现多次";
    //   } else {
    //     return this.checkExpression(content, varablies);    // 不是case开头直接检查表达式
    //   }
    //   return "未发现问题";
    // },
    //父组件点击树状图其它节点切换的时候提醒保存
    change(func, node) {
      this.exitDialogVisiable = true;
      this.exitFunc = func;
      this.exitNode= node;
    },
    //取消退出
    cancelExit(){
      this.exitDialogVisiable = false;
      this.$emit('testback');
    },
    confirmExit(){
      this.exitDialogVisiable = false;
      this.exitFunc(this.exitNode);
    },

  },
}
</script>
<style lang="less">
#wholePage {
  height: 100%;
  height: 721px;

  #create {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%;
    height: 80%;
    position: relative;

    #content {
      position: relative;
      height: 100vh;
      float: left;
      background-color: #ffffff;
      width: 80%;
      overflow-y: scroll;
    }

    #right_menu {
      position: relative;
      height: 100vh;
      width: 20%;
      float: right;
      background-color: #ececec;
      overflow-y: scroll;
    }

  }

  .modeBtns2 {
    width: 100%;
    left: 0
  }

  .modeBtns {
    height: 7%;
    width: 100%;
    background-color: #ececec;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    transition: opacity 0.5s;
    z-index: 99999;

    &:hover {
      opacity: 1;
    }

    el-button {
      width: 8%;
    }

  }
}
</style>
